import { render, staticRenderFns } from "./ImpersonateForm.vue?vue&type=template&id=70dd5b19"
import script from "./ImpersonateForm.vue?vue&type=script&lang=js"
export * from "./ImpersonateForm.vue?vue&type=script&lang=js"
import style0 from "./ImpersonateForm.vue?vue&type=style&index=0&id=70dd5b19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports